import madeStore from "components/jiffy/vue-product-details-print/store/store";
import { MODES } from "components/jiffy/vue-product-details-print/misc/constants";
import ScrollToElement from "common/utils/ui/scroll-to-element";
import "./pdp-made-banner.scss";

const $getBanner = () => document.querySelector(".js-pdp-made-banner");

const init = () => {
  $getBanner()?.addEventListener("click", () => {
    madeStore.commit("app/setMode", MODES.MADE);

    setTimeout(() => {
      ScrollToElement.scrollIntoViewBySelector(".js-pdp-experience-switcher");
    }, 0);
  });
};

export default init;
